import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        email: '',
        message: ''
    });
    const [status, setStatus] = useState('');

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus('sending');

        try {
            const response = await fetch(process.env.REACT_APP_FORMSPREE_API, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            });

            if (response.ok) {
                setStatus('success');
                setFormData({ name: '', phone: '', email: '', message: '' });
            } else {
                setStatus('error');
            }
        } catch (error) {
            setStatus('error');
        }
    };

    return (
        <div className="contact-page fade-in">
            <div className="container">
                <div className="contact-header">
                    <span className="contact-tag">Let's Create Something Amazing</span>
                    <h1>Get in Touch</h1>
                    <p>Have questions about our functionality? Want to collaborate? Or just want to say hello? <strong>We're here to help you succeed!</strong></p>
                </div>

                <div className="contact-grid">
                    {/* Form Section */}
                    <div className="contact-form-card">
                        <h2>Send Us a Message</h2>
                        <p className="form-subtitle">Fill out the form below and we'll get back to you as soon as possible.</p>

                        <form onSubmit={handleSubmit}>
                            <div className="form-row">
                                <div className="form-group">
                                    <label htmlFor="name">Full Name</label>
                                    <input
                                        type="text"
                                        id="name"
                                        name="name"
                                        placeholder="John Doe"
                                        value={formData.name}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="phone">Phone Number</label>
                                    <input
                                        type="tel"
                                        id="phone"
                                        name="phone"
                                        placeholder="+252 ..."
                                        value={formData.phone}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>

                            <div className="form-group">
                                <label htmlFor="email">Email Address</label>
                                <input
                                    type="email"
                                    id="email"
                                    name="email"
                                    placeholder="john@example.com"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="message">Message</label>
                                <textarea
                                    id="message"
                                    name="message"
                                    placeholder="Tell us more about your inquiry..."
                                    rows="4"
                                    value={formData.message}
                                    onChange={handleChange}
                                    required
                                ></textarea>
                            </div>

                            <button type="submit" className="submit-btn" disabled={status === 'sending'}>
                                {status === 'sending' ? 'Sending...' : (
                                    <>
                                        Send Message
                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                            <line x1="22" y1="2" x2="11" y2="13"></line>
                                            <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
                                        </svg>
                                    </>
                                )}
                            </button>

                            {status === 'success' && (
                                <p className="status-msg success">Message sent successfully!</p>
                            )}
                            {status === 'error' && (
                                <p className="status-msg error">Failed to send. Please try again.</p>
                            )}
                        </form>
                    </div>

                    {/* Info Section */}
                    <div className="contact-info">
                        <h2>Other Ways to Connect</h2>
                        <p className="info-subtitle">Choose the method that works best for you. We're here to help!</p>

                        <a href="mailto:yousufmoha255@gmail.com" className="info-card">
                            <div className="icon-box email">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                                    <polyline points="22,6 12,13 2,6"></polyline>
                                </svg>
                            </div>
                            <div className="info-text">
                                <h3>Email Support</h3>
                                <span className="info-label">GET A RESPONSE WITHIN 24 HOURS</span>
                                <span className="info-value">yousufmoha255@gmail.com</span>
                            </div>
                            <div className="arrow-icon">→</div>
                        </a>

                        <a href="https://wa.me/252906680955" target="_blank" rel="noopener noreferrer" className="info-card">
                            <div className="icon-box whatsapp">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path>
                                </svg>
                            </div>
                            <div className="info-text">
                                <h3>WhatsApp Chat</h3>
                                <span className="info-label">QUICK RESPONSE ON WHATSAPP</span>
                                <span className="info-value">+252 90 668 0955</span>
                            </div>
                            <div className="arrow-icon">→</div>
                        </a>

                        <div className="info-card">
                            <div className="icon-box location">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                                    <circle cx="12" cy="10" r="3"></circle>
                                </svg>
                            </div>
                            <div className="info-text">
                                <h3>Virtual Office</h3>
                                <span className="info-label">CONNECT WITH US ONLINE</span>
                                <span className="info-value">Always Available</span>
                            </div>
                            <div className="arrow-icon">→</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contact;
